module.exports = __webpack_public_path__ + "img/music-database.5dd64e2b.png";